import { Box, Checkbox, CheckboxGroup, FormControl, FormHelperText, FormLabel, SimpleGrid } from '@chakra-ui/react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';

export default function CheckboxGroupFormField({ name = null, label = null, options = [], columns = 2, spacing = 4, required = false }) {
	const { t } = useTranslation('common');

	return (
		<Field name={name}>
			{({ field, meta, form }) => {
				return (
					<Box mb="4">
						<FormControl id={name}>
							{label && (
								<FormLabel>
									{t(label)}
									{required && <span style={{ color: 'red' }}>*</span>}
								</FormLabel>
							)}
							<CheckboxGroup defaultValue={field?.value} onChange={(e) => form.setFieldValue(name, e)}>
								<SimpleGrid columns={columns} spacing={spacing}>
									{options?.map((option, index) => {
										return (
											<Checkbox key={index} value={option?.value}>
												{option?.label}
											</Checkbox>
										);
									})}
								</SimpleGrid>
							</CheckboxGroup>
							{meta.touched && meta.error && (
								<FormHelperText id="error-message-password" color="red.400" fontSize="12px">
									{t(label)} {t('is')} {t(meta.error)}
								</FormHelperText>
							)}
						</FormControl>
					</Box>
				);
			}}
		</Field>
	);
}
